<template>
  <div ref="tooltip" class="map-tooltip" v-bind:style="position" v-show="tooltipData && position && open">
    <template v-if="tooltipData">
      <div class="map-tooltip__header">
        <h4 class="title is-5">{{tooltipData.countryName}}</h4>
        <a href="javascript:" @click="close">
          <span class="icon" v-icon:close></span>
        </a>
      </div>
      <div class="map-tooltip__body">
        <div class="map-tooltip__logos">
          <figure v-for="brand in tooltipData.brands" :style="{'background-color': brand.color}">
            <img :src="brand.logo">
          </figure>
        </div>
        <div class="map-tooltip__content">
          <slot name="tooltip-content"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
    export default {
        name: "BrandsMapTooltip",
        props: {
            open: {
                type: Boolean,
                default: false
            },
            tooltipData: {
                type: Object
            },
            position: {
                type: Object
            }
        },
        methods: {
          close() {
              this.$emit('update:open', false)
              this.$emit('close');
          }
        }
    }
</script>

<style scoped>

</style>
